var SongList = require('../SongList'),
	extend = require('util')._extend;

module.exports = DynamicSongList;

//Auto-updating song list based on saved search parameters
function DynamicSongList(listName, searchParams, queryParams) {
	SongList.call(this, listName);
	
	//IMPORTANT NOTE:
	//We did not start storing searchParams until 7/3/16 (previously we only stored queryParams)
	this.searchParams = searchParams || null;
	this.queryParams = queryParams || null;
}

DynamicSongList.prototype = Object.create(SongList.prototype);

extend(DynamicSongList.prototype, {
	constructor: DynamicSongList

	//Construct a query that will return all the songs in this list
  , getSongsQueryParams: function(orderBy) {
        //searchParams are required for dynamic lists, but just in case...
        if (!this.queryParams) {
            return false;
        }
        var query = this.queryParams;
        query.$orderby = orderBy || {sortTitle:1};
        return query;
	}

  , toJson: function() {
        return {
            id: this.id
          , name: this.name
          , searchParams: this.searchParams
			//need to convert Mongo query to JSON string because MongoDB does not
			//allow field names beginning with $ or containing dots.
		  , queryParams: JSON.stringify(this.queryParams)
          , userId: this.userId
		  , institutionalSubscriptionId: this.institutionalSubscriptionId
		  , shared: this.shared
		  , creatorEmail: this.creatorEmail
		  , editCode: this.editCode
		  , timeCreated: this.timeCreated
          , _prototype: 'DynamicSongList'
        };
	}
});